// extracted by mini-css-extract-plugin
export var layoutContainer = "_71-0";
export var layoutContainerNoRounding = "_71-6";
export var layoutContainerOpen = "_71-5";
export var layoutContainerResizing = "_71-1";
export var mainContent = "_71-2";
export var resizeDivider = "_71-3";
export var slidePanel = "_71-4";